import React from "react";
import _ from "lodash";
import glamorous from "glamorous";
import { Button } from "react-bootstrap";
import { InputCell } from "../location-edit/LocationEditForm";
import TrashCan from "react-icons/lib/fa/trash";

const CoordIndex = glamorous.span({
  backgroundColor: "yellow"
});

export const PolygonalForm = ({ data }) => {
  // FIXME: this form only handles one polygon
  const coordinates = _.get(data, "geofence.geometry.coordinates[0]", []);
  const existingCoords = coordinates.slice(0, -1).map((coord, i) => {
    const [lng, lat] = coord;
    return (
      <tr key={`coord-${i}`}>
        <td>
          <CoordIndex>{i + 1}</CoordIndex>
        </td>
        <td>
          <InputCell value={lat} />
        </td>
        <td>
          <InputCell value={lng} />
        </td>
        <td>
          <TrashCan />
        </td>
      </tr>
    );
  });
  return (
    <table>
      <thead>
        <tr>
          <th />
          <th>Latitude</th>
          <th>Longitude</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {existingCoords}
        <tr>
          <td>
            <CoordIndex>{coordinates.length}</CoordIndex>
          </td>
          <td>
            <InputCell />
          </td>
          <td>
            <InputCell />
          </td>
          <td>
            <Button>Add</Button>
          </td>
        </tr>
      </tbody>
    </table>
  );
};



// WEBPACK FOOTER //
// ./src/modules/geofence-edit/GeofenceEditPolygonalForm.js